module.exports = __webpack_public_path__ + "static/media/main.18272166.png";